export default __webpack_public_path__ + "static/media/facebook.2ca05ac4.svg";